import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import CreditCardForm from '../CreditCardForm/CreditCardForm';
import { RadioButton } from '../../../forms/elements';
import GiftCardForm from '../GiftCardForm/GiftCardForm';
import GiftCardApplied from '../GiftCardApplied/GiftCardApplied';
import { cartDuck } from '../../../../ducks/cart';
import { connect } from 'react-redux';
import { removeTipAndEntitlementsOptions } from '../../../../util/constants';
import applePayImage from '../../../../images/apple-pay-logo-icon.png';
import gPayImage from '../../../../images/gpay.png';
import { useFlags } from 'launchdarkly-react-client-sdk';

function CheckoutPayment(props) {
  var _props$cart;

  var setFieldValue = props.setFieldValue,
      setGlobalState = props.setGlobalState,
      errors = props.errors,
      paymentType = props.paymentType,
      setPaymentType = props.setPaymentType,
      mixedCart = props.mixedCart,
      setFieldTouched = props.setFieldTouched,
      values = props.values,
      validateHandler = props.validateHandler;
  var tokenxRef = useRef(null);
  var giftCardRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      canShowZipError = _useState2[0],
      setCanShowZipError = _useState2[1];

  var _useState3 = useState({
    status: 'not-applied',
    balance: 0,
    message: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      giftCardInfo = _useState4[0],
      setGiftCardInfo = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedPaymentTypes = _useState6[0],
      setSelectedPaymentTypes = _useState6[1];

  var flags = useFlags();
  var isApplePayEnabled = (flags === null || flags === void 0 ? void 0 : flags['showApplePayPaymentOption']) !== undefined ? flags === null || flags === void 0 ? void 0 : flags['showApplePayPaymentOption'] : true;
  var isGooglePayEnabled = (flags === null || flags === void 0 ? void 0 : flags['showGooglePayPaymentOption']) !== undefined ? flags === null || flags === void 0 ? void 0 : flags['showGooglePayPaymentOption'] : true;

  var scrolToFirstError = function scrolToFirstError() {
    var error = document.querySelector('.is-error') || document.querySelector('.tokenx-form__error');

    if (error) {
      var y = error.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: y - 70,
        behavior: 'smooth'
      });
    }
  };

  var removeGiftCard = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var index;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return props.removeTipAndEntitlements([removeTipAndEntitlementsOptions.giftCard]);

            case 3:
              setGiftCardInfo({
                status: 'not-applied',
                balance: 0,
                message: null
              });
              setFieldValue('giftCardNumber', '0000000000000000000');
              setFieldValue('giftCardPin', '0000');
              setFieldValue('giftCardApplied', true);
              index = paymentType.indexOf('gift');
              setSelectedPaymentTypes(paymentType.filter(function (_, i) {
                return i !== index;
              }));
              setPaymentType(['card']);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              console.error('Error on Reset Tip and Entitlements request: ', _context.t0.message);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function removeGiftCard() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var isShowingCard = paymentType.includes('card');
    setFieldValue('cardNumber', isShowingCard ? '' : 'XXXX XXXX XXXX XXXX');
    setFieldValue('expDate', isShowingCard ? '' : 'MM/YY');
    setFieldValue('cvv', isShowingCard ? '' : 'XXX');
    setFieldValue('billingZip', isShowingCard ? '' : '00000');
    setGlobalState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isValidCard: !isShowingCard,
        isValidExpiry: !isShowingCard,
        isValidCVV: !isShowingCard
      });
    });

    if (paymentType.length === 1) {
      setFieldValue('giftCardNumber', paymentType.includes('gift') ? '' : '0000000000000000000');
      setFieldValue('giftCardPin', paymentType.includes('gift') ? '' : '0000');
      setFieldValue('giftCardApplied', !paymentType.includes('gift'));
    }

    if (paymentType.includes('gift')) {
      setFieldTouched('giftCardNumber', false);
      setFieldTouched('giftCardPin', false);
    } else {
      setGiftCardInfo({
        status: 'not-applied',
        balance: 0,
        message: null
      });
    }

    if (selectedPaymentTypes.length) {
      setPaymentType(selectedPaymentTypes);
      setSelectedPaymentTypes([]);
    }
  }, [paymentType]);

  var submitHandler = function submitHandler() {
    if (paymentType.includes('card')) {
      var _tokenxRef$current, _tokenxRef$current$va;

      (_tokenxRef$current = tokenxRef.current) === null || _tokenxRef$current === void 0 ? void 0 : (_tokenxRef$current$va = _tokenxRef$current.validate) === null || _tokenxRef$current$va === void 0 ? void 0 : _tokenxRef$current$va.call(_tokenxRef$current);
      setCanShowZipError(true);
    }

    setTimeout(function () {
      scrolToFirstError();
    }, 500);
  };

  useEffect(function () {
    document.addEventListener('submit-clicked', submitHandler);
    return function () {
      document.removeEventListener('submit-clicked', submitHandler);
    };
  }, [paymentType]);

  var handleSelectPaymentType = function handleSelectPaymentType(value) {
    validateHandler(values).then(function () {
      if (paymentType.length > 1) {
        setPaymentType(['gift', value]);
      } else {
        setPaymentType([value]);
      }
    }).catch(function (e) {
      console.error('Error validating the cart: ', e.message);
    });
  };

  var renderOption = function renderOption(value, label, disabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioButton, {
      disabled: disabled,
      name: "paymentType",
      value: value,
      id: "paymentType-".concat(value),
      checked: paymentType === null || paymentType === void 0 ? void 0 : paymentType.includes(value),
      onChange: function onChange() {
        handleSelectPaymentType(value);
      },
      className: "cb-type-body-sm pt-12",
      labelClass: paymentType.includes(value) ? "is-active" : null
    }, label && /*#__PURE__*/React.createElement("label", {
      className: 'cb-payment-type__label',
      htmlFor: "paymentType-".concat(value)
    }, label), value === 'applePay' && /*#__PURE__*/React.createElement("img", {
      className: "cb-checkout__payment-logo cb-checkout__payment-logo--apple",
      src: applePayImage,
      alt: "Apple Pay Logo"
    }), value === 'googlePay' && /*#__PURE__*/React.createElement("img", {
      className: "cb-checkout__payment-logo cb-checkout__payment-logo--google",
      src: gPayImage,
      alt: "Google Pay Logo"
    })), value === 'gift' && /*#__PURE__*/React.createElement("div", {
      className: 'cb-checkout__payment-gift-separator'
    }));
  };

  var giftCardOption = /*#__PURE__*/React.createElement(React.Fragment, null, !mixedCart && renderOption('gift', 'Pay with Gift Card'), (paymentType === null || paymentType === void 0 ? void 0 : paymentType.includes('gift')) && /*#__PURE__*/React.createElement(GiftCardForm, {
    cart: props.cart,
    getGiftCardBalance: props.getGiftCardBalance,
    setPaymentType: setPaymentType,
    giftCardInfo: giftCardInfo,
    setGiftCardInfo: setGiftCardInfo,
    setFieldValue: setFieldValue,
    errors: errors,
    setFieldTouched: setFieldTouched
  }));
  var giftCardApplied = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GiftCardApplied, {
    cart: props.cart,
    giftCardInfo: giftCardInfo,
    removeGiftCard: removeGiftCard,
    setPaymentType: setPaymentType,
    setGiftCardInfo: setGiftCardInfo
  }));
  var applePayOption = /*#__PURE__*/React.createElement(React.Fragment, null, !mixedCart && renderOption('applePay'));
  var googlePayOption = /*#__PURE__*/React.createElement(React.Fragment, null, !mixedCart && renderOption('googlePay'));
  var creditCardOption = /*#__PURE__*/React.createElement(React.Fragment, null, renderOption('card', 'Pay with Credit Card'), (paymentType === null || paymentType === void 0 ? void 0 : paymentType.includes('card')) && /*#__PURE__*/React.createElement(CreditCardForm, {
    canShowZipError: canShowZipError,
    setCanShowZipError: setCanShowZipError,
    tokenxRef: tokenxRef,
    setFieldValue: setFieldValue,
    setGlobalState: setGlobalState,
    errors: errors
  }));

  switch (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) {
    case 'not-applied':
    case 'error':
      return /*#__PURE__*/React.createElement("div", {
        className: "payment-section"
      }, (props === null || props === void 0 ? void 0 : (_props$cart = props.cart) === null || _props$cart === void 0 ? void 0 : _props$cart.giftCardScheme) && giftCardOption, window.ApplePaySession && props.cart.applePayScheme && isApplePayEnabled && applePayOption, props.cart.googlePayScheme && isGooglePayEnabled && googlePayOption, creditCardOption);

    case 'applied-not-cover':
      return /*#__PURE__*/React.createElement("div", {
        className: "payment-section"
      }, giftCardApplied, window.ApplePaySession && props.cart.applePayScheme && isApplePayEnabled && applePayOption, props.cart.googlePayScheme && isGooglePayEnabled && googlePayOption, creditCardOption);

    case 'applied-covers':
      return /*#__PURE__*/React.createElement("div", {
        className: "payment-section"
      }, giftCardApplied);
  }
}

var cartOperations = cartDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getGiftCardBalance: function getGiftCardBalance(giftCardData) {
      return dispatch(cartOperations.handleGetGiftCardBalance(giftCardData));
    },
    removeTipAndEntitlements: function removeTipAndEntitlements(data) {
      return dispatch(cartOperations.handleRemoveTipAndEntitlements(data));
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    cart: state.cart
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPayment);